import { styled } from '@mui/material/styles';
import { Tabs } from '@mui/material';

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.getContrastText(theme.palette.primary.dark),

  '& .MuiTab-root': {
    color: 'inherit',
    opacity: 0.8,
    minWidth: 160,
    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
    },

    '&.Mui-selected': {
      color: 'inherit',
      opacity: 1,
    },
  },

  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export const TabContent = styled('div')(({ theme }) => ({
  maxWidth: theme.breakpoints.values['content'],
  margin: 'auto',
  textAlign: 'left',
}));

// Class-name string lookups (Tab item.className may be 'noPad' or undefined)
export const tabClassLookup = {
  noPad: 'rt-tab-nopad',
};

// Wrapper applied around the tab area that defines the global no-pad rule
export const TabsWrapper = styled('div')({
  flexGrow: 1,

  '& .rt-tab-nopad': {
    padding: '0 !important',
  },
});

export const PrintHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(1),
  width: '100%',
}));

export const PrintHeaderTitles = styled('div')({
  flex: '1 1 auto',
  minWidth: 0,
  textAlign: 'left',
});

export const PrintHeaderLogo = styled('div')({
  flex: '0 0 auto',
  display: 'flex',
  justifyContent: 'flex-end',
});
